import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusPopupComponent } from './status-popup.component';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';



@NgModule({
  declarations: [StatusPopupComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatDialogModule
  ],
  exports: [
    StatusPopupComponent
  ]
})
export class StatusPopupModule { }
